export enum Paths {
  MAIN = '/',
  LOGIN = '/login',
  RESTORE_PASSWORD = '/restore-password',
  SIGN_UP = '/sign-up',
  USERS_MANAGEMENT = '/users-management',
  COMMUNITIES = '/communities',
  NEW_COMMUNITY = '/new-community',
  PROPERTIES = '/properties',
  MANAGEMENT = '/management',
  PROPERTY = '/property',
  UPLOAD_CSV = '/upload-csv',
  INSPECTIONS = '/inspections',
  CODE = '/code',
  NEW_PASSWORD = '/new-password',
  ADD_INSPECTION = '/add-inspection',
  COMPANIES = '/companies',
  NEW_COMPANY = '/new-company',
}
